import Icon from 'components/Icon';
import styled from 'styled-components';
import {commonPalette} from 'styles/palette';

export const StyledIcon = styled(Icon).attrs(p => ({
  name: p.value === false ? 'checklists-close' : 'checkmark'
}))`
  width: 14px;
  height: 14px;
  color: ${({value}) => (value === false ? commonPalette.feedbackError : commonPalette.feedbackSuccess)};
`;

export const IconWrapper = styled.div`
  padding: 4px 8px;
  border-radius: 4px;
  display: inline-flex;
  align-items: flex-start;
  gap: 10px;
  background-color: ${({value}) => (value === false ? commonPalette.bannerError : commonPalette.bannerSuccess)};
  margin-right: 5px;
`;
